import axios from 'axios'
// eslint-disable-next-line import/no-internal-modules
import { publish } from '@insided/deprecated-utils/globals'

export async function bulkApprove(posts: Object[]) {
  return await axios.post('/community/api/bulk/process', {
    action: 'approve',
    topics: posts
  })
}

export async function permanentlyDeleteSpamPosts(posts: Object[]) {
  await axios.post('/community/api/bulk/process', {
    action: 'permanentlyDelete',
    topics: posts
  })

  await axios.post('/community/api/invalidateCache?apiPath=spamContent/count')
  publish('posts_permanently_deleted_spam', {})
}
